import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';
import { useWindowWidth } from 'components/shared/Stepper/hooks/useWindowWidth';

const KioskFooterPanel = ({
  practiceEmail,
  qrImage,
  isLoadingQr,
  onDownloadQr,
  onSendQrToEmail,
  onOpenEmailModal
}) => {
  const { windowWidth } = useWindowWidth(0);
  const shouldShowLabels = windowWidth > 1200 || (windowWidth > 856 && windowWidth <= 1056);
  const isCompactLayout = windowWidth < 500;
  const qrSize = isCompactLayout ? 58 : 84;

  return (
    <div
      className={cn(
        'my-3 flex w-full items-center justify-between rounded-lg bg-primary-25 px-6 py-2',
        isCompactLayout && 'flex-col items-start gap-3'
      )}>
      <div className="flex items-center gap-2.5">
        <div className="rounded-lg border border-solid border-neutral-200 bg-white p-2">
          <Icon size={32} icon="kiosk-mono" color="primary" />
        </div>
        <div className="flex flex-col gap-0.5">
          <p className="font-600">Patient check-in access</p>
          <p className="text-sm">Use the QR code to enable patient self check-in.</p>
        </div>
      </div>
      <div className={cn('flex items-center gap-3', isCompactLayout && 'w-full justify-end')}>
        <Button
          iconShade={900}
          color="neutral"
          variant="tertiary"
          text={shouldShowLabels ? 'Download' : ''}
          onClick={onDownloadQr}
          size="small"
          className="rounded-md"
          icon="import-mono"
        />
        <Popover
          options={[
            {
              label: practiceEmail,
              onClick: onSendQrToEmail
            },
            {
              label: 'Custom email address',
              onClick: onOpenEmailModal
            }
          ]}
          isFixed
          menuPortalTarget={document.body}
          position="right"
          text={shouldShowLabels ? 'Email' : ''}
          icon="send-mono"
          buttonTheme="tertiary"
          buttonClassName="bg-white hover:bg-neutral-100 border border-solid border-neutral-200 h-10 rounded"
          iconRight="chevron-down-2-linear"
          iconRightClassName="ml-2"
        />
        {isLoadingQr ? (
          <div
            className="animate-pulse rounded bg-neutral-100"
            style={{ width: qrSize, height: qrSize }}
          />
        ) : qrImage ? (
          <img
            src={qrImage}
            alt="Patient check-in QR code"
            width={qrSize}
            height={qrSize}
            className="rounded"
          />
        ) : (
          <div className="rounded bg-neutral-100" style={{ width: qrSize, height: qrSize }} />
        )}
      </div>
    </div>
  );
};

export default KioskFooterPanel;
